module.exports = __webpack_public_path__ + "static/media/press_content_12.88216b98.png";